import React from 'react'
import icons from './../../../utils/import.icons'
import mobileAndTabletCheck from './../../../utils/mobileCheck'

let imageSize = ["100vw", "100vh"];
let barOffset = 0;
if (mobileAndTabletCheck() && window.innerHeight > window.innerWidth) {
  barOffset = 5;
  imageSize = ["calc(84vh * 1.77778)", "84vh"];
}

let Amenities: any = [[{
    name:"Senderos Peatonales",
    tipo:"Senderos Peatonales",
    verts:[[892.63,389.264]]
    },{
    name:"Terraza Área Social",
    tipo:"Terraza Área Social",
    verts:[[929.706,369.494]]
    },{
    name:"Salón Lounge",
    tipo:"Salón Lounge",
    verts:[[936.282,365.674]]
    },],[{
    name:"Senderos Peatonales",
    tipo:"Senderos Peatonales",
    verts:[[899.841,388.918]]
    },{
    name:"Terraza Área Social",
    tipo:"Terraza Área Social",
    verts:[[949.574,369.858]]
    },{
    name:"Salón Lounge",
    tipo:"Salón Lounge",
    verts:[[962.917,366.185]]
    },],[{
    name:"Senderos Peatonales",
    tipo:"Senderos Peatonales",
    verts:[[912.451,390.106]]
    },{
    name:"Terraza Área Social",
    tipo:"Terraza Área Social",
    verts:[[973.262,372.039]]
    },{
    name:"Salón Lounge",
    tipo:"Salón Lounge",
    verts:[[992.793,368.619]]
    },],[{
    name:"Senderos Peatonales",
    tipo:"Senderos Peatonales",
    verts:[[929.008,392.541]]
    },{
    name:"Terraza Área Social",
    tipo:"Terraza Área Social",
    verts:[[999.451,375.634]]
    },{
    name:"Salón Lounge",
    tipo:"Salón Lounge",
    verts:[[1024.64,372.531]]
    },],[{
    name:"Senderos Peatonales",
    tipo:"Senderos Peatonales",
    verts:[[948.287,395.919]]
    },{
    name:"Terraza Área Social",
    tipo:"Terraza Área Social",
    verts:[[1027.18,380.256]]
    },{
    name:"Salón Lounge",
    tipo:"Salón Lounge",
    verts:[[1057.61,377.523]]
    },],[{
    name:"Senderos Peatonales",
    tipo:"Senderos Peatonales",
    verts:[[969.521,400.266]]
    },{
    name:"Terraza Área Social",
    tipo:"Terraza Área Social",
    verts:[[1055.87,385.929]]
    },{
    name:"Salón Lounge",
    tipo:"Salón Lounge",
    verts:[[1091.24,383.659]]
    },],[{
    name:"Senderos Peatonales",
    tipo:"Senderos Peatonales",
    verts:[[991.638,406.392]]
    },{
    name:"Terraza Área Social",
    tipo:"Terraza Área Social",
    verts:[[1084.3,393.06]]
    },{
    name:"Salón Lounge",
    tipo:"Salón Lounge",
    verts:[[1124.26,391.231]]
    },],[{
    name:"Senderos Peatonales",
    tipo:"Senderos Peatonales",
    verts:[[1011.86,413.706]]
    },{
    name:"Terraza Área Social",
    tipo:"Terraza Área Social",
    verts:[[1110.76,400.348]]
    },{
    name:"Salón Lounge",
    tipo:"Salón Lounge",
    verts:[[1155.32,398.717]]
    },],[{
    name:"Senderos Peatonales",
    tipo:"Senderos Peatonales",
    verts:[[1029.71,419.835]]
    },{
    name:"Terraza Área Social",
    tipo:"Terraza Área Social",
    verts:[[1135.73,406.56]]
    },{
    name:"Salón Lounge",
    tipo:"Salón Lounge",
    verts:[[1185.17,405.162]]
    },],[{
    name:"Senderos Peatonales",
    tipo:"Senderos Peatonales",
    verts:[[1048.62,424.981]]
    },{
    name:"Terraza Área Social",
    tipo:"Terraza Área Social",
    verts:[[1161.74,412.282]]
    },{
    name:"Salón Lounge",
    tipo:"Salón Lounge",
    verts:[[1216.11,411.236]]
    },],[{
    name:"Senderos Peatonales",
    tipo:"Senderos Peatonales",
    verts:[[1070.38,430.045]]
    },{
    name:"Terraza Área Social",
    tipo:"Terraza Área Social",
    verts:[[1190.11,418.239]]
    },{
    name:"Salón Lounge",
    tipo:"Salón Lounge",
    verts:[[1249.31,417.646]]
    },],[{
    name:"Senderos Peatonales",
    tipo:"Senderos Peatonales",
    verts:[[1093.55,435.353]]
    },{
    name:"Terraza Área Social",
    tipo:"Terraza Área Social",
    verts:[[1219.6,424.611]]
    },{
    name:"Salón Lounge",
    tipo:"Salón Lounge",
    verts:[[1283.62,424.547]]
    },],[{
    name:"Senderos Peatonales",
    tipo:"Senderos Peatonales",
    verts:[[1116.59,441.032]]
    },{
    name:"Terraza Área Social",
    tipo:"Terraza Área Social",
    verts:[[1248.84,431.463]]
    },{
    name:"Salón Lounge",
    tipo:"Salón Lounge",
    verts:[[1317.81,432.002]]
    },],[{
    name:"Senderos Peatonales",
    tipo:"Senderos Peatonales",
    verts:[[1137.96,447.116]]
    },{
    name:"Terraza Área Social",
    tipo:"Terraza Área Social",
    verts:[[1276.38,438.817]]
    },{
    name:"Salón Lounge",
    tipo:"Salón Lounge",
    verts:[[1350.47,440.036]]
    },],[{
    name:"Senderos Peatonales",
    tipo:"Senderos Peatonales",
    verts:[[1156.17,453.555]]
    },{
    name:"Terraza Área Social",
    tipo:"Terraza Área Social",
    verts:[[1300.76,446.627]]
    },{
    name:"Salón Lounge",
    tipo:"Salón Lounge",
    verts:[[1380.2,448.619]]
    },],[{
    name:"Senderos Peatonales",
    tipo:"Senderos Peatonales",
    verts:[[1169.82,460.257]]
    },{
    name:"Terraza Área Social",
    tipo:"Terraza Área Social",
    verts:[[1320.49,454.82]]
    },{
    name:"Salón Lounge",
    tipo:"Salón Lounge",
    verts:[[1405.47,457.694]]
    },],[{
    name:"Senderos Peatonales",
    tipo:"Senderos Peatonales",
    verts:[[1177.66,467.063]]
    },{
    name:"Terraza Área Social",
    tipo:"Terraza Área Social",
    verts:[[1334.12,463.263]]
    },{
    name:"Salón Lounge",
    tipo:"Salón Lounge",
    verts:[[1424.78,467.149]]
    },],[{
    name:"Senderos Peatonales",
    tipo:"Senderos Peatonales",
    verts:[[1178.67,473.751]]
    },{
    name:"Terraza Área Social",
    tipo:"Terraza Área Social",
    verts:[[1340.42,471.76]]
    },{
    name:"Salón Lounge",
    tipo:"Salón Lounge",
    verts:[[1436.73,476.812]]
    },],[{
    name:"Senderos Peatonales",
    tipo:"Senderos Peatonales",
    verts:[[1174.72,480.462]]
    },{
    name:"Terraza Área Social",
    tipo:"Terraza Área Social",
    verts:[[1340.81,480.501]]
    },{
    name:"Salón Lounge",
    tipo:"Salón Lounge",
    verts:[[1442.51,486.903]]
    },],[{
    name:"Senderos Peatonales",
    tipo:"Senderos Peatonales",
    verts:[[1168.63,487.449]]
    },{
    name:"Terraza Área Social",
    tipo:"Terraza Área Social",
    verts:[[1337.75,489.776]]
    },{
    name:"Salón Lounge",
    tipo:"Salón Lounge",
    verts:[[1444.33,497.744]]
    },],[{
    name:"Senderos Peatonales",
    tipo:"Senderos Peatonales",
    verts:[[1161.08,494.614]]
    },{
    name:"Terraza Área Social",
    tipo:"Terraza Área Social",
    verts:[[1331.69,499.498]]
    },{
    name:"Salón Lounge",
    tipo:"Salón Lounge",
    verts:[[1442.43,509.268]]
    },],[{
    name:"Senderos Peatonales",
    tipo:"Senderos Peatonales",
    verts:[[1152.72,501.864]]
    },{
    name:"Terraza Área Social",
    tipo:"Terraza Área Social",
    verts:[[1323.11,509.569]]
    },{
    name:"Salón Lounge",
    tipo:"Salón Lounge",
    verts:[[1437.07,521.387]]
    },],[{
    name:"Senderos Peatonales",
    tipo:"Senderos Peatonales",
    verts:[[1144.23,509.108]]
    },{
    name:"Terraza Área Social",
    tipo:"Terraza Área Social",
    verts:[[1312.6,519.878]]
    },{
    name:"Salón Lounge",
    tipo:"Salón Lounge",
    verts:[[1428.71,533.998]]
    },],[{
    name:"Senderos Peatonales",
    tipo:"Senderos Peatonales",
    verts:[[1136.24,516.268]]
    },{
    name:"Terraza Área Social",
    tipo:"Terraza Área Social",
    verts:[[1300.73,530.318]]
    },{
    name:"Salón Lounge",
    tipo:"Salón Lounge",
    verts:[[1417.77,546.982]]
    },],[{
    name:"Senderos Peatonales",
    tipo:"Senderos Peatonales",
    verts:[[1129.28,523.281]]
    },{
    name:"Terraza Área Social",
    tipo:"Terraza Área Social",
    verts:[[1288.08,540.786]]
    },{
    name:"Salón Lounge",
    tipo:"Salón Lounge",
    verts:[[1404.74,560.222]]
    },],[{
    name:"Senderos Peatonales",
    tipo:"Senderos Peatonales",
    verts:[[1123.78,530.104]]
    },{
    name:"Terraza Área Social",
    tipo:"Terraza Área Social",
    verts:[[1275.15,551.182]]
    },{
    name:"Salón Lounge",
    tipo:"Salón Lounge",
    verts:[[1390.05,573.588]]
    },],[{
    name:"Senderos Peatonales",
    tipo:"Senderos Peatonales",
    verts:[[1120.03,536.705]]
    },{
    name:"Terraza Área Social",
    tipo:"Terraza Área Social",
    verts:[[1262.38,561.42]]
    },{
    name:"Salón Lounge",
    tipo:"Salón Lounge",
    verts:[[1374.11,586.957]]
    },],[{
    name:"Senderos Peatonales",
    tipo:"Senderos Peatonales",
    verts:[[1118.18,543.069]]
    },{
    name:"Terraza Área Social",
    tipo:"Terraza Área Social",
    verts:[[1250.02,571.418]]
    },{
    name:"Salón Lounge",
    tipo:"Salón Lounge",
    verts:[[1357.2,600.194]]
    },],[{
    name:"Senderos Peatonales",
    tipo:"Senderos Peatonales",
    verts:[[1118.24,549.19]]
    },{
    name:"Terraza Área Social",
    tipo:"Terraza Área Social",
    verts:[[1238.26,581.111]]
    },{
    name:"Salón Lounge",
    tipo:"Salón Lounge",
    verts:[[1339.55,613.188]]
    },],[{
    name:"Senderos Peatonales",
    tipo:"Senderos Peatonales",
    verts:[[1120.04,555.067]]
    },{
    name:"Terraza Área Social",
    tipo:"Terraza Área Social",
    verts:[[1227.08,590.429]]
    },{
    name:"Salón Lounge",
    tipo:"Salón Lounge",
    verts:[[1321.17,625.804]]
    },],[{
    name:"Senderos Peatonales",
    tipo:"Senderos Peatonales",
    verts:[[1123.31,560.694]]
    },{
    name:"Terraza Área Social",
    tipo:"Terraza Área Social",
    verts:[[1216.28,599.298]]
    },{
    name:"Salón Lounge",
    tipo:"Salón Lounge",
    verts:[[1301.92,637.902]]
    },],[{
    name:"Senderos Peatonales",
    tipo:"Senderos Peatonales",
    verts:[[1127.58,566.044]]
    },{
    name:"Terraza Área Social",
    tipo:"Terraza Área Social",
    verts:[[1205.5,607.612]]
    },{
    name:"Salón Lounge",
    tipo:"Salón Lounge",
    verts:[[1281.46,649.291]]
    },],[{
    name:"Senderos Peatonales",
    tipo:"Senderos Peatonales",
    verts:[[1132.31,571.076]]
    },{
    name:"Terraza Área Social",
    tipo:"Terraza Área Social",
    verts:[[1194.22,615.253]]
    },{
    name:"Salón Lounge",
    tipo:"Salón Lounge",
    verts:[[1259.32,659.771]]
    },],[{
    name:"Senderos Peatonales",
    tipo:"Senderos Peatonales",
    verts:[[1136.8,575.705]]
    },{
    name:"Terraza Área Social",
    tipo:"Terraza Área Social",
    verts:[[1181.75,622.038]]
    },{
    name:"Salón Lounge",
    tipo:"Salón Lounge",
    verts:[[1234.83,669.051]]
    },],[{
    name:"Senderos Peatonales",
    tipo:"Senderos Peatonales",
    verts:[[1140.27,579.804]]
    },{
    name:"Terraza Área Social",
    tipo:"Terraza Área Social",
    verts:[[1167.34,627.744]]
    },{
    name:"Salón Lounge",
    tipo:"Salón Lounge",
    verts:[[1207.23,676.796]]
    },],[{
    name:"Senderos Peatonales",
    tipo:"Senderos Peatonales",
    verts:[[1141.87,583.199]]
    },{
    name:"Terraza Área Social",
    tipo:"Terraza Área Social",
    verts:[[1150.11,632.096]]
    },{
    name:"Salón Lounge",
    tipo:"Salón Lounge",
    verts:[[1175.71,682.613]]
    },],[{
    name:"Terraza Área Social",
    tipo:"Terraza Área Social",
    verts:[[1130.6,634.3]]
    },{
    name:"Senderos Peatonales",
    tipo:"Senderos Peatonales",
    verts:[[1141.89,585.235]]
    },{
    name:"Salón Lounge",
    tipo:"Salón Lounge",
    verts:[[1141.04,685.562]]
    },],[{
    name:"Salón Lounge",
    tipo:"Salón Lounge",
    verts:[[1104.56,685.145]]
    },{
    name:"Terraza Área Social",
    tipo:"Terraza Área Social",
    verts:[[1109.83,633.925]]
    },{
    name:"Senderos Peatonales",
    tipo:"Senderos Peatonales",
    verts:[[1141.03,585.522]]
    },],[{
    name:"Salón Lounge",
    tipo:"Salón Lounge",
    verts:[[1066.29,681.512]]
    },{
    name:"Terraza Área Social",
    tipo:"Terraza Área Social",
    verts:[[1087.59,631.147]]
    },{
    name:"Senderos Peatonales",
    tipo:"Senderos Peatonales",
    verts:[[1138.94,584.218]]
    },],[{
    name:"Salón Lounge",
    tipo:"Salón Lounge",
    verts:[[1026.25,674.679]]
    },{
    name:"Terraza Área Social",
    tipo:"Terraza Área Social",
    verts:[[1063.62,626.069]]
    },{
    name:"Senderos Peatonales",
    tipo:"Senderos Peatonales",
    verts:[[1135.23,581.462]]
    },],[{
    name:"Salón Lounge",
    tipo:"Salón Lounge",
    verts:[[984.722,664.547]]
    },{
    name:"Terraza Área Social",
    tipo:"Terraza Área Social",
    verts:[[1037.7,618.635]]
    },{
    name:"Senderos Peatonales",
    tipo:"Senderos Peatonales",
    verts:[[1129.47,577.357]]
    },],[{
    name:"Salón Lounge",
    tipo:"Salón Lounge",
    verts:[[942.652,651.309]]
    },{
    name:"Terraza Área Social",
    tipo:"Terraza Área Social",
    verts:[[1010.02,608.592]]
    },{
    name:"Senderos Peatonales",
    tipo:"Senderos Peatonales",
    verts:[[1121.17,571.878]]
    },],[{
    name:"Salón Lounge",
    tipo:"Salón Lounge",
    verts:[[900.911,636.077]]
    },{
    name:"Terraza Área Social",
    tipo:"Terraza Área Social",
    verts:[[981.481,596.283]]
    },{
    name:"Senderos Peatonales",
    tipo:"Senderos Peatonales",
    verts:[[1109.9,564.709]]
    },],[{
    name:"Salón Lounge",
    tipo:"Salón Lounge",
    verts:[[859.552,619.884]]
    },{
    name:"Terraza Área Social",
    tipo:"Terraza Área Social",
    verts:[[952.531,582.912]]
    },{
    name:"Senderos Peatonales",
    tipo:"Senderos Peatonales",
    verts:[[1095.92,555.312]]
    },],[{
    name:"Salón Lounge",
    tipo:"Salón Lounge",
    verts:[[818.516,603.126]]
    },{
    name:"Terraza Área Social",
    tipo:"Terraza Área Social",
    verts:[[922.854,569.213]]
    },{
    name:"Senderos Peatonales",
    tipo:"Senderos Peatonales",
    verts:[[1080.42,544.258]]
    },],[{
    name:"Salón Lounge",
    tipo:"Salón Lounge",
    verts:[[778.081,585.969]]
    },{
    name:"Terraza Área Social",
    tipo:"Terraza Área Social",
    verts:[[892.316,555.316]]
    },{
    name:"Senderos Peatonales",
    tipo:"Senderos Peatonales",
    verts:[[1063.54,533.078]]
    },],[{
    name:"Salón Lounge",
    tipo:"Salón Lounge",
    verts:[[738.701,568.645]]
    },{
    name:"Terraza Área Social",
    tipo:"Terraza Área Social",
    verts:[[861.122,541.308]]
    },{
    name:"Senderos Peatonales",
    tipo:"Senderos Peatonales",
    verts:[[1044.59,522.298]]
    },],[{
    name:"Salón Lounge",
    tipo:"Salón Lounge",
    verts:[[700.983,551.404]]
    },{
    name:"Terraza Área Social",
    tipo:"Terraza Área Social",
    verts:[[829.697,527.329]]
    },{
    name:"Senderos Peatonales",
    tipo:"Senderos Peatonales",
    verts:[[1023.31,511.84]]
    },],[{
    name:"Salón Lounge",
    tipo:"Salón Lounge",
    verts:[[665.564,534.545]]
    },{
    name:"Terraza Área Social",
    tipo:"Terraza Área Social",
    verts:[[798.581,513.587]]
    },{
    name:"Senderos Peatonales",
    tipo:"Senderos Peatonales",
    verts:[[999.888,501.665]]
    },],[{
    name:"Salón Lounge",
    tipo:"Salón Lounge",
    verts:[[633.153,518.36]]
    },{
    name:"Terraza Área Social",
    tipo:"Terraza Área Social",
    verts:[[768.426,500.319]]
    },{
    name:"Senderos Peatonales",
    tipo:"Senderos Peatonales",
    verts:[[974.713,491.85]]
    },],[{
    name:"Salón Lounge",
    tipo:"Salón Lounge",
    verts:[[604.37,503.149]]
    },{
    name:"Terraza Área Social",
    tipo:"Terraza Área Social",
    verts:[[739.898,487.783]]
    },{
    name:"Senderos Peatonales",
    tipo:"Senderos Peatonales",
    verts:[[948.343,482.555]]
    },],[{
    name:"Salón Lounge",
    tipo:"Salón Lounge",
    verts:[[579.844,489.185]]
    },{
    name:"Terraza Área Social",
    tipo:"Terraza Área Social",
    verts:[[713.721,476.234]]
    },{
    name:"Senderos Peatonales",
    tipo:"Senderos Peatonales",
    verts:[[921.453,473.981]]
    },],[{
    name:"Salón Lounge",
    tipo:"Salón Lounge",
    verts:[[560.069,476.717]]
    },{
    name:"Terraza Área Social",
    tipo:"Terraza Área Social",
    verts:[[690.562,465.921]]
    },{
    name:"Senderos Peatonales",
    tipo:"Senderos Peatonales",
    verts:[[894.802,466.352]]
    },],[{
    name:"Salón Lounge",
    tipo:"Salón Lounge",
    verts:[[545.372,465.955]]
    },{
    name:"Terraza Área Social",
    tipo:"Terraza Área Social",
    verts:[[670.995,457.064]]
    },{
    name:"Senderos Peatonales",
    tipo:"Senderos Peatonales",
    verts:[[869.18,459.898]]
    },],[{
    name:"Salón Lounge",
    tipo:"Salón Lounge",
    verts:[[540.285,456.412]]
    },{
    name:"Terraza Área Social",
    tipo:"Terraza Área Social",
    verts:[[659.572,449.246]]
    },{
    name:"Senderos Peatonales",
    tipo:"Senderos Peatonales",
    verts:[[849.124,454.255]]
    },],[{
    name:"Salón Lounge",
    tipo:"Salón Lounge",
    verts:[[547.659,447.769]]
    },{
    name:"Terraza Área Social",
    tipo:"Terraza Área Social",
    verts:[[659.419,442.166]]
    },{
    name:"Senderos Peatonales",
    tipo:"Senderos Peatonales",
    verts:[[838.121,449.125]]
    },],[{
    name:"Salón Lounge",
    tipo:"Salón Lounge",
    verts:[[564.759,440.324]]
    },{
    name:"Terraza Área Social",
    tipo:"Terraza Área Social",
    verts:[[668.383,436.097]]
    },{
    name:"Senderos Peatonales",
    tipo:"Senderos Peatonales",
    verts:[[834.825,444.751]]
    },],[{
    name:"Salón Lounge",
    tipo:"Salón Lounge",
    verts:[[588.54,434.2]]
    },{
    name:"Terraza Área Social",
    tipo:"Terraza Área Social",
    verts:[[683.871,431.154]]
    },{
    name:"Senderos Peatonales",
    tipo:"Senderos Peatonales",
    verts:[[837.323,441.248]]
    },],[{
    name:"Salón Lounge",
    tipo:"Salón Lounge",
    verts:[[615.943,429.326]]
    },{
    name:"Terraza Área Social",
    tipo:"Terraza Área Social",
    verts:[[703.137,427.281]]
    },{
    name:"Senderos Peatonales",
    tipo:"Senderos Peatonales",
    verts:[[843.385,438.576]]
    },],[{
    name:"Salón Lounge",
    tipo:"Salón Lounge",
    verts:[[644.29,425.489]]
    },{
    name:"Terraza Área Social",
    tipo:"Terraza Área Social",
    verts:[[723.657,424.28]]
    },{
    name:"Senderos Peatonales",
    tipo:"Senderos Peatonales",
    verts:[[850.786,436.566]]
    },],[{
    name:"Salón Lounge",
    tipo:"Salón Lounge",
    verts:[[671.349,422.347]]
    },{
    name:"Terraza Área Social",
    tipo:"Terraza Área Social",
    verts:[[743.248,421.833]]
    },{
    name:"Senderos Peatonales",
    tipo:"Senderos Peatonales",
    verts:[[857.477,434.93]]
    },],[{
    name:"Salón Lounge",
    tipo:"Salón Lounge",
    verts:[[695.443,419.486]]
    },{
    name:"Terraza Área Social",
    tipo:"Terraza Área Social",
    verts:[[760.197,419.545]]
    },{
    name:"Senderos Peatonales",
    tipo:"Senderos Peatonales",
    verts:[[861.741,433.298]]
    },],[{
    name:"Salón Lounge",
    tipo:"Salón Lounge",
    verts:[[715.39,416.428]]
    },{
    name:"Terraza Área Social",
    tipo:"Terraza Área Social",
    verts:[[773.243,416.957]]
    },{
    name:"Senderos Peatonales",
    tipo:"Senderos Peatonales",
    verts:[[862.239,431.231]]
    },],[{
    name:"Salón Lounge",
    tipo:"Salón Lounge",
    verts:[[732.834,412.481]]
    },{
    name:"Terraza Área Social",
    tipo:"Terraza Área Social",
    verts:[[784.15,413.431]]
    },{
    name:"Senderos Peatonales",
    tipo:"Senderos Peatonales",
    verts:[[861.016,428.246]]
    },],[{
    name:"Salón Lounge",
    tipo:"Salón Lounge",
    verts:[[750.555,407.36]]
    },{
    name:"Terraza Área Social",
    tipo:"Terraza Área Social",
    verts:[[795.727,408.74]]
    },{
    name:"Senderos Peatonales",
    tipo:"Senderos Peatonales",
    verts:[[860.964,424.257]]
    },],[{
    name:"Salón Lounge",
    tipo:"Salón Lounge",
    verts:[[769.314,401.24]]
    },{
    name:"Terraza Área Social",
    tipo:"Terraza Área Social",
    verts:[[808.531,403.064]]
    },{
    name:"Senderos Peatonales",
    tipo:"Senderos Peatonales",
    verts:[[862.275,419.417]]
    },],[{
    name:"Salón Lounge",
    tipo:"Salón Lounge",
    verts:[[789.615,394.353]]
    },{
    name:"Terraza Área Social",
    tipo:"Terraza Área Social",
    verts:[[822.901,396.634]]
    },{
    name:"Senderos Peatonales",
    tipo:"Senderos Peatonales",
    verts:[[864.992,413.921]]
    },],[{
    name:"Salón Lounge",
    tipo:"Salón Lounge",
    verts:[[811.737,387.067]]
    },{
    name:"Terraza Área Social",
    tipo:"Terraza Área Social",
    verts:[[838.98,389.803]]
    },{
    name:"Senderos Peatonales",
    tipo:"Senderos Peatonales",
    verts:[[869.021,408.059]]
    },],[{
    name:"Salón Lounge",
    tipo:"Salón Lounge",
    verts:[[835.635,379.878]]
    },{
    name:"Terraza Área Social",
    tipo:"Terraza Área Social",
    verts:[[856.622,383.045]]
    },{
    name:"Senderos Peatonales",
    tipo:"Senderos Peatonales",
    verts:[[874.058,402.216]]
    },],[{
    name:"Salón Lounge",
    tipo:"Salón Lounge",
    verts:[[860.928,373.482]]
    },{
    name:"Terraza Área Social",
    tipo:"Terraza Área Social",
    verts:[[875.374,377.016]]
    },{
    name:"Senderos Peatonales",
    tipo:"Senderos Peatonales",
    verts:[[879.598,396.921]]
    },],[{
    name:"Senderos Peatonales",
    tipo:"Senderos Peatonales",
    verts:[[884.893,392.793]]
    },{
    name:"Salón Lounge",
    tipo:"Salón Lounge",
    verts:[[886.78,368.7]]
    },{
    name:"Terraza Área Social",
    tipo:"Terraza Área Social",
    verts:[[894.385,372.486]]
    },],[{
    name:"Senderos Peatonales",
    tipo:"Senderos Peatonales",
    verts:[[889.01,390.467]]
    },{
    name:"Salón Lounge",
    tipo:"Salón Lounge",
    verts:[[911.902,366.379]]
    },{
    name:"Terraza Área Social",
    tipo:"Terraza Área Social",
    verts:[[912.427,370.249]]
    },],]


let amenitiess = []

interface Billboards{
    billboard: any
}

interface Props{
    amenity: any,
    angle: number,
    gallery: any,
    openGallery: any,
    show: boolean,
    leftOffset: number,
    zoom: number,
    topOffset: number
}

interface State{
    angle: number,
    pos: any,
    transition: boolean
}

class Billboards extends React.Component<Props, State>{
    constructor(props: Props){
        super(props)
        this.state = {
            angle: 0,
            pos: [],
            transition: false
        }
    }

    componentDidMount(){
        this.billboard = <div></div>
    }

    createBillboards = () => {
        
        if(this.props.amenity.Nombre !== ''){
            
            if(Amenities[this.props.angle].length > 0){
                
                this.billboard = <div></div>
                for(let i = 0; i < Amenities[this.props.angle].length; i++)
                {
                    if(Amenities[this.props.angle][i].name === this.props.amenity.Nombre){
  
                        
                        
                        /*this.setState(prevState => ({
                            pos: Amenities[this.props.angle][i].pos
                        }), 
                        () => {*/
                            this.billboard = <svg 
                            width={"100%"}
                            height={"100%"}
                            preserveAspectRatio="XminYmin slice"
                            viewBox="0 0 1920 1080"
                            style={{
                                overflow: 'hidden',
                                pointerEvents: 'none',
                                position: 'absolute'
                            }}>
                                <g style={{
                                    pointerEvents: this.props.show ? 'visibleFill':'none'
                                }}
                                onClick = {this.props.gallery.length > 0 ? this.props.openGallery:null}
                                onTouchStart = {this.props.gallery.length > 0 ? this.props.openGallery:null}
                                >
                                    <circle 
                                        cx={Amenities[this.props.angle][i].verts[0][0]} 
                                        cy={Amenities[this.props.angle][i].verts[0][1]} 
                                        r="30" 
                                        style = {{
                                            fill:"rgba(90,89,92,.85)",
                                            stroke:"rgba(255,255,255,.85)",
                                            strokeWidth:1
                                        }}
                                    />
                                    <image 
                                        href={icons[this.props.amenity.Nombre + '2']}
                                        width="30"
                                        height="30"
                                        x={Amenities[this.props.angle][i].verts[0][0]-15}
                                        y={Amenities[this.props.angle][i].verts[0][1]-15}
                                        /*style={{
                                            position: 'absolute',
                                            left:this.state.pos[0],
                                            top:this.state.pos[1]
                                        }}*/
                                        
                                    ></image>
                                </g>
                                
                            </svg>;
                            
                        //})
                        break;
                    }                    
                }
            } 
            else
            {
                this.billboard = <div></div>
            }
            
        }
    }

    componentDidUpdate(prevProps: any){
        if(mobileAndTabletCheck() && window.innerHeight > window.innerWidth){
            barOffset = 5;
            imageSize = ['calc(84% * 1.77778)', '84%'];
        }
        else {
          imageSize = ['100%', '100%'];
          barOffset = 0;
        }
  
        // TODO: check if this routine can be optimized
        
        if(!this.props.show){
            return
        } 

        if(prevProps.amenity !== this.props.amenity){
            this.setState({transition:true})
            setTimeout(function(this: any){
                this.setState({
                    transition: false,
                })
                this.createBillboards();
                this.forceUpdate();   
            }.bind(this), 250)
        }
                
        if(prevProps.angle !== this.props.angle || prevProps.show !== this.props.show){
            //console.log(this.props)
            this.createBillboards();
            this.forceUpdate();        
        }
    }
  
    render() {
        return (
            <div
                style={{
                    pointerEvents: 'none',
                    width: imageSize[0],
                    height: imageSize[1],
                    transform: 'scale('+this.props.zoom+') translate(calc(' + this.props.leftOffset + '%), calc(' + barOffset + '% + ' + this.props.topOffset + '%))'
                }}
                className={this.props.show && !this.state.transition ? "billboards fade-in":"billboards fade-out"}
            >
                {this.billboard}
            </div>
            
        );
      
    }

}

export default Billboards